module.exports = __webpack_public_path__ + "static/plan-actions-beth-4dc34da4042b669a2e2db82a4ff55a9b.svg";